import { render, staticRenderFns } from "./rightList.vue?vue&type=template&id=548bd695&scoped=true"
import script from "./rightList.vue?vue&type=script&lang=js"
export * from "./rightList.vue?vue&type=script&lang=js"
import style0 from "./rightList.vue?vue&type=style&index=0&id=548bd695&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548bd695",
  null
  
)

export default component.exports